module.exports = __webpack_public_path__ + "static/media/video.93187693.mp4";